import { postCreateNewPatient } from 'api';
import { useMutation, UseMutationResult } from 'react-query';
import { ICreateNewPatientErrorResponse, ICreateNewPatientPayload, ICreateNewPatientSuccessResponse } from 'models';

interface Props {
  onSuccess?: (res: ICreateNewPatientSuccessResponse) => void;
  onError?: (err: ICreateNewPatientErrorResponse) => void;
}

export const usePostCreateNewPatient = ({
  onSuccess,
  onError,
}: Props): UseMutationResult<
  ICreateNewPatientSuccessResponse,
  ICreateNewPatientErrorResponse,
  ICreateNewPatientPayload
> => {
  const mutation = useMutation((props: ICreateNewPatientPayload) => postCreateNewPatient(props), {
    onSuccess: (res) => {
      if (res.status === 'ok') {
        if (onSuccess) onSuccess(res);
        return;
      }

      alert(res.message);
    },
    onError: (err: any) => {
      if (onError) {
        onError(err);
      }

      alert(err.response.message);
    },
  });

  return mutation;
};

export default usePostCreateNewPatient;
